import { OpenAPI } from '@klangio/ai2notes-ts-client';
import { type TranscriptionDialogContextValue } from '../context/TranscriptionDialogContext/TranscriptionDialogContext';
import { type JobType, type SheetSourceType, type TranscriptionState } from '../entities';
import getEnvMode from '../utils/env';

export const SUPPORTED_FILE_TYPES = [
  'audio/mpeg',
  'audio/flac',
  'audio/x-flac',
  'audio/wav',
  'audio/vnd.wave',
  'audio/mp4',
  'audio/m4a',
  'audio/x-m4a',
  'audio/x-wav',
  'audio/x-aiff',
  'audio/ogg',
  'audio/vorbis',
  'audio/x-mpegurl',
  'video/mp4',
  'audio/midi',
  'audio/mid',
  'audio/x-midi',
  'audio/aiff',
  'audio/mp3',
];

export const SUPPORTED_SCAN_TYPES = [
  'application/pdf',
  'application/x-pdf',
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/apng',
  'image/avif',
];

// eslint-disable-next-line vars-on-top, import/no-mutable-exports, no-var
export var BASE_URL = 'https://ai2notes.klang.io';

export function SET_BASE_URL(url: string) {
  BASE_URL = url;
}

// eslint-disable-next-line vars-on-top, import/no-mutable-exports, no-var
export var LOCAL_DEV = true;

export function SET_LOCAL_DEV(local: boolean) {
  LOCAL_DEV = local;
}

export function GET_BASE_URL() {
  if (!LOCAL_DEV || getEnvMode() === 'production' || getEnvMode() === 'development') {
    return BASE_URL;
  }
  return 'https://localhost:44327';
}

export interface TranscriptionProgressData {
  progress: number;
  jobState: TranscriptionState | string;
  message: string;
  demo?: boolean;
}

export interface TranscriptionFinishData {
  state: TranscriptionState;
  id: string;
}

export interface TranscriptionUpdate {
  Id: string;
  title?: string;
  rating?: number;
  deleted?: boolean;
}

export class backendService {
  /**
   * Make sure this is set for axios to
   * add http-only cookies to http request
   */
  static initOpenApi = () => {
    OpenAPI.WITH_CREDENTIALS = true;
    OpenAPI.BASE = 'https://ai2notes.klang.io';
  };

  static setOpenApiToken = (sessionToken: string) => {
    OpenAPI.TOKEN = sessionToken;
  };

  static setAxiosResponseTypeToBlob = () => {
    OpenAPI.AXIOS_CONFIG = {
      responseType: 'blob',
    };
  };

  static clearAxiosConfig = () => {
    OpenAPI.AXIOS_CONFIG = undefined;
  };


  static transcribeFile(
    file: File,
    useTickets: boolean,
    params: {
      apriori: TranscriptionDialogContextValue['apriori'];
      settings?: TranscriptionDialogContextValue['settings'];
    },
    source: SheetSourceType,
    jobType?: JobType,
    token?: string,
    onProgress?: (perc: number) => void,
    callback?: (jobId: string) => void,
  ) {
    const formData = new FormData();
    formData.append('file', file);
    if (typeof useTickets === 'string') {
      formData.append('usecredits', useTickets);
      formData.append('usetickets', useTickets);
    } else {
      formData.append('usecredits', `${useTickets}`);
      formData.append('usetickets', `${useTickets}`);
    }
    formData.append('source', source);
    formData.append('type', jobType);
    formData.append('params', JSON.stringify(params));

    formData.append('title', params.apriori.title);
    const request = new XMLHttpRequest();
    request.open('POST', `${GET_BASE_URL()}/api/transcription/upload`);

    // authentication token
    if (token) {
      request.setRequestHeader('Authorization', `Bearer ${token}`);
    }

    request.onload = () => {
      const json = JSON.parse(request.responseText);
      if (callback) callback(json.jobId);
    };
    request.upload.addEventListener(
      'progress',
      (e) => {
        if (e.lengthComputable && onProgress) {
          const perc = Math.floor((100 * e.loaded) / e.total);
          onProgress(perc);
        }
      },
      false,
    );

    request.addEventListener(
      'progress',
      (e) => {
        if (e.lengthComputable) {
          const perc = Math.floor((100 * e.loaded) / e.total);
          onProgress(perc);
        }
      },
      false,
    );

    request.send(formData);
  }
}
